<template>
  
  <div><!-- 封装弹框 -->
  <div style="width:900px;margin-left:15px;margin-top:10px">
              
     <div class="d-flex" v-loading="qaDialogload">
          <div style="width:70%">
          <el-form ref="form" :model="form" label-width="100px" :rules="rules" class="form_application">
            <div class="propreinfor" style="  border-top: 1px solid rgb(192, 196, 204);">
            <el-form-item  :label="$t('tableText.보낸사람')" class="mb-0">
              <div class="d-flex contant">
                 <el-input v-model="form.user_id" class="w-25"></el-input>
                  <el-input v-model="form.mem_name" class="w-25 ml-2"></el-input>
             <div class="ml-auto">{{form.add_time}}</div></div>
            </el-form-item>
          </div>
           <div class="propreinfor">
            <el-form-item :label="$t('msg.제목')" class="mb-0">
              <div class="contant bluecolor">
                 <el-input v-model="form.user_title" style="color:#409EFF !important"></el-input>
            
            </div>
            </el-form-item>
          </div>
          <div class="propreinfor">
          <el-form-item :label="$t('msg.내용')"  class="mb-0">
            <div class="contant bluecolor">
            <div class="qa-user-contents" v-html="userContentsHtml"></div>
        </div>
            
            </el-form-item>
          </div>
          <div class="propreinfor">
              <el-form-item :label="$t('msg.답변제목')" class="mb-0">
                <div class="contant d-flex">
              <el-input v-model="form.admin_title" class="w-50"></el-input><span class="ml-auto">{{form.re_time}}</span>
            </div>
            </el-form-item>
          </div>
           <div class="propreinfor">
          <el-form-item :label="$t('msg.답변내용')"  class="mb-0">
           <!--  <el-input
            type="textarea"
            :rows="10"
            v-model="form.admin_contents">
          </el-input> -->
          <div class="contant">
              <quill-editor 
                                v-model="form.admin_contents" 
                                ref="myQuillEditor" 
                                :options="editorOption" 
                                @blur="onEditorBlur($event)" 
                                @focus="onEditorFocus($event)"
                              @change="onEditorChange($event)">
                      </quill-editor>
                      <input type="file" @change="change" id="upload" style="display:none;" />
                    </div>
            </el-form-item>
           </div>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="submitStatus" style="float:right;" v-if="form.status == '0'" class="ml-2" type="primary">{{$t('msg.보류')}}</el-button>
            <el-button v-if="form.status == '1'" @click="submit" style="float:right;">{{$t('msg.수정')}}</el-button>
            <el-button v-if="form.status != '1'" @click="submit" style="float:right;">{{$t('msg.답변')}}</el-button>

            
          </span>
          </div>
          <div class="border ml-auto p-2 d-flex" style="width:29%;flex-direction:column;align-items:start;height:450px;overflow-y:auto;"> 
            <el-button type="text" v-for="(item,index) in qa" :key="index"  class="py-2 ml-0" @click="qaChange(index)">{{item.title2}}</el-button>
          
          </div>
        </div>
           
  </div>

       


  </div>
</template>
<script>
 import DOMPurify from 'dompurify';
 
 import { quillEditor, Quill  } from "vue-quill-editor";
Quill.register('modules/ImageExtend', ImageExtend)
import {ImageExtend, QuillWatch } from "quill-image-extend-module"
import "quill/dist/quill.core.css"; 
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
  export default{
     components: {
    quillEditor
    },
    props:{
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      layerid:{
        type:String,
        default:""
      },
    
    
    
    },
  
      data(){
        return{
           editorOption: {
           
            modules:{
            
              toolbar: {
                container:[
                     ['bold', 'italic', 'underline', 'strike'],  
                   
                     [{'list': 'ordered'}, {'list': 'bullet'}], 
                     ["image",'video','link'],
                     [{'color': []}, {'background': []}],
                    
                     [{'header': [1, 2, 3, 4, 5, 6, false]}],
                     
                ],
                 handlers: {
                    image(value) {
                      if (value) {
                        
                        document.querySelector('#upload').click()
                      } else {
                        this.quill.format('image', false)
                      }
                    },
                  },

              },
            },
             
            },
          domain:window.sessionStorage.getItem('domain'),
          qaDialogload:false,
            qa:[],
          form:{
                  id:'',
                  user_title:'',
                  user_id:'',
                  user_contents:'',
                  add_time:'',
                  admin_contents:'',
                  admin_title:'',
                  mem_name:'',
                  re_time:'',
                  status:''
          
            
                },
                 rules: {
                  username: [
                    { required: true, message:this.$i18n.t("msg.입력해주세요"), trigger: 'blur' },
                   
                  ],
                   phone: [
                    { required: true, message:this.$i18n.t("msg.입력해주세요"), trigger: 'blur' },
                  
                  ],
                    address: [
                    { required: true, message:this.$i18n.t("msg.입력해주세요"), trigger: 'blur' },
                   
                  ],
                  
                   total_price: [
                    { required: true, message:this.$i18n.t("msg.입력해주세요"), trigger: 'blur' },
                  
                  ],

      }
           
          
        }
      },
        created() {
          // this.info.id父组件传给子组件的id值
          this.qaSend(this.info.id);
         

          
             
    },
    computed: {
      userContentsHtml() {
        const contents = String(this.form.user_contents == null ? '' : this.form.user_contents);
        // Sanitize both HTML and tag-free HTML entities without double escaping.
        return DOMPurify.sanitize(contents);
      },
      editor() {
        return this.$refs.myQuillEditor.quill;
    }
  },
      methods:{
         change(e) {
          let token=window.sessionStorage.getItem('user');
          let file = e.target.files[0]
          const formData = new FormData()
          formData.append('file', file)
          this.$axios({
　　　　　　　　　　url: this.domain+'/admin/fileu',
　　　　　　　　　　method: 'post',
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
　　　　　　　　　　data: formData,
　　　　　　　　　
　　　　　　　　}).then((url) => {
                    console.log('url:',url.data.data)
                     const quill = this.$refs.myQuillEditor.quill
                      quill.focus()
                      quill.insertEmbed(quill.getSelection().index, 'image', url.data.data)
                            　　　　　　　　　　
　　　　　　　　　
　　　　　　　　}).catch(err => {
          console.error(err)
        })

    
    },

          onEditorReady(editor) { // 准备编辑器
        },
          onEditorBlur(){}, // 失去焦点事件
          onEditorFocus(){}, // 获得焦点事件
          onEditorChange(event){
              // console.log(event.html)
               this.form.admin_contents = event.html
          }, 
         qaSend(id){
          //console.log('id',id)
            let token=window.sessionStorage.getItem('user');
          this.qaDialogload = true
        
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/qa?id='+id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 
               console.log('data====',response.data.auto_qa)
                  let item = response.data.data 
                  this.form ={
                    id: item.id,
                    user_id : item.user_id,
                    user_title : item.user_title,
                    user_contents : item.user_contents,
                    add_time : item.add_time,
                    admin_title : item.admin_title,
                    admin_contents : item.admin_contents,
                    mem_name : item.mem_name,
                    re_time : item.re_time,
                    status: item.status
                  }
                  this.qa = response.data.auto_qa
                   this.qaDialogload = false    
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
             
         
      },
      submitStatus(){
          let token=window.sessionStorage.getItem('user');
          
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/qa_up',
                      data:{  
                            id:this.form.id,
                           status:'2'
                      },
                            
                'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    if(response.data.code!=200){
                      this.$message.error(response.data.msg)
                    }
                    this.$message({
                      message:this.$i18n.t("msg.완료"),
                  type:'success'
                    })

                    return;
                    
                    this.$parent.getList()


           
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                    
          
        },
      qaChange(index){
          //console.log(index)
          this.form.admin_title = this.qa[index].title
          this.form.admin_contents = this.qa[index].contents
        },
        submit(){
          this.qaDialogload = true

          let token=window.sessionStorage.getItem('user');
          
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/qa_up',
                      data:{  
                            id:this.form.id,
                            admin_title:this.form.admin_title,
                            admin_contents:this.form.admin_contents,
                      },
                            
                'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    if(response.data.code!=200){
                      this.$message.error(response.data.msg)
                      this.qaDialogload = false
                      return;
                    }
                    this.$message({
                      message:this.$i18n.t("msg.완료"),
                  type:'success'
                    })
                    this.qaDialogload = false
                    this.$parent.getList()


                          //关闭
           this.$layer.close(this.layerid)
                
                          
                           
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                    
          
        },
          
       
       
       
      
      }
  }
</script>
<style scoped>
.qa-user-contents {
  min-height: 54px;
  max-height: 180px;
  overflow: auto;
  padding: 5px 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #333;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.qa-user-contents >>> img {
  max-width: 100%;
  height: auto;
}

>>>.ql-editor{
  height: 155px;
}
>>>.ql-snow .ql-picker{
  height: auto;
}
.form_application{
  margin-bottom:5px;
}
.form_application .propreinfor {
         border-left: 1px solid rgb(192, 196, 204);
      
        margin: 0 auto;
        position:relative;


}
.form_application .contant {
       
        padding:5px;
        border-right: 1px solid rgb(192, 196, 204);
        border-bottom: 1px solid rgb(192, 196, 204);
        height: 100% !important;

}
>>>.el-form-item__label {
        
       position:absolute;
       margin:0px;
        border-right: 1px solid rgb(192, 196, 204);
        border-bottom: 1px solid rgb(192, 196, 204);
        padding: 10px;
        background: #f9f9f9;
        font-weight: 400;
        color: #000;
        line-height: normal;
        display: flex;
        align-items: center;
        justify-content: left;
          height: 100% !important;

      }
      >>>.bluecolor .el-input__inner,>>>.bluecolor .el-textarea__inner{
        color:#333 !important;font-weight:bold
      }
</style>



// WEBPACK FOOTER //
// src/components/common/qa-dialog.vue